export const ChartModel = {
    Individual: 0,
    MovingRange: 1,
    XBAR: 2,
    Range: 3
}